import { useEffect, useRef } from 'react';

import { AbsoluteCenter, Box } from '@chakra-ui/react';
import { FRAuth, TokenManager } from '@forgerock/javascript-sdk/src/index';
import { useRouter } from 'next/router';

import { logOut } from '@/pages/authenticate';

import CenteredLoader from '@/components/organism/dashboard/CenteredLoader/CenteredLoader';
import { VENDOR_AUTH_INTENT_KEY } from '@/constants/storage.constants';
import { pushEvent } from '@/helpers/analytics';
import { seedVendorAuthenticationSession } from '@/helpers/session';
import { useUAEPassSession } from '@/hooks/useUAEPassSession';

const VendorUAEPassAuth = () => {
  const router = useRouter();
  const { initiateUAE } = useUAEPassSession();
  const initiated = useRef(false);

  const initiateLogin = async () => {
    // Mark vendor intent so /authenticate redirects to vendor registration on success
    localStorage.setItem(VENDOR_AUTH_INTENT_KEY, 'true');

    initiateUAE(false);
    pushEvent('login', {
      method: 'uaepass',
      portal: 'vendor',
      device_type: /Mobi|Android/i.test(navigator.userAgent)
        ? 'mobile'
        : 'desktop',
    });

    try {
      const stepZero: any = await FRAuth.start();

      if (stepZero.type === 'LoginSuccess') {
        // Already has a valid session (e.g. logged in via customer portal) - finalize vendor auth without re-prompting UAE Pass
        await TokenManager.getTokens({ forceRenew: true });
        seedVendorAuthenticationSession();
        router.push('/vendor/registration');
        return;
      }

      const stepOne: any = await FRAuth.next(stepZero);
      FRAuth.redirect(stepOne);
    } catch (err) {
      console.error(err, '--Vendor UAE Pass login failed--');
      localStorage.removeItem(VENDOR_AUTH_INTENT_KEY);
      logOut();
      router.push('/');
    }
  };

  useEffect(() => {
    if (!router.isReady || initiated.current) return;
    initiated.current = true;
    initiateLogin();
  }, [router.isReady]);

  return (
    <Box position="relative" h="100vh">
      <AbsoluteCenter axis="both">
        <CenteredLoader />
      </AbsoluteCenter>
    </Box>
  );
};

export default VendorUAEPassAuth;
